import { useCallback } from 'react';
import { useSetTripFilters } from './useTripStoreSelectors';

// Sets one tripFilters property, keeping the others.
export function useUpdateTripFilter() {
  const setTripFilters = useSetTripFilters();
  return useCallback(
    (property: string, value: unknown) =>
      setTripFilters((current: any) => ({ ...current, [property]: value })),
    [setTripFilters],
  );
}
